import * as React from "react";
import {map as _map} from "lodash";
import {IAdvicePrescription} from "@curefit/care-common";

/**
 * Created by abhinav on 28/01/18.
 */

export interface PatientLifeStyleViewProps {
    lifeStyle: IAdvicePrescription[];
}

class PatientLifeStyleView extends React.Component<PatientLifeStyleViewProps> {

    constructor(props: PatientLifeStyleViewProps) {
        super(props);
    }

    render() {
        return (
            <div className="patient-lifestyle-view">
                {
                    _map(this.props.lifeStyle, function(lifestyle: IAdvicePrescription, index: number) {
                        return (
                            <div className="lifeStyle-tag" key={index}>
                                <div className="lifeStyle-name">{lifestyle.name}</div>
                                <div className="lifeStyle-instructions">{lifestyle.instruction}</div>
                            </div>
                        )
                    })
                }
            </div>
        );
    }
}

export default PatientLifeStyleView;